export default import.meta.ROLLDOWN_FILE_URL_50uZzMDuKmRebB_W5Jz06w